import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { AddWebPhoto, AddWebPhotoVariables } from '../../../athena/types/AddWebPhoto';
import { WebPhotoFields } from '../../../fragments/web/WebPhotoFields';

export const MUTATION = gql`
  mutation AddWebPhoto($key: String!, $kind: String!, $picableId: String!, $picableType: String!) {
    webMaintenance {
      addWebPhoto(
        input: { key: $key, kind: $kind, picableId: $picableId, picableType: $picableType }
      ) {
        photo {
          ...WebPhotoFields
        }
      }
    }
  }
  ${WebPhotoFields}
`;

const useAddWebPhoto = () => useMutation<AddWebPhoto, AddWebPhotoVariables>(MUTATION);

export default useAddWebPhoto;
